import api from '@edu-fe/api'

const module = {
  name: 'distribution',

  get: (courseId, type) => {
    return api.create(`/popular/share?courseId=${courseId}&type=${type}`)
  }
}

export default module
